import Socialshare from "../../../../components/socialShare"
import { useAppSelector } from "../../../../store/hooks"

const Socialinsureone = () => {
  const { detail } = useAppSelector(state => state.campaign)
  return (
    <>
      <div className="c-code-qr">
        <Socialshare
          title="Let us do the shopping for you!"
          url={detail.social_post_auto_1}
          textButton="Download Image"
          nameFile="social_1"
        />
        <Socialshare
          title="Bringing you peace of mind for"
          url={detail.social_post_auto_2}
          textButton="Download Image"
          nameFile="social_2"
        />
      </div>
      <div className="c-code-qr">
        <Socialshare
          title="Bringing you peace of mind for"
          url={detail.social_post_auto_3}
          textButton="Download Image"
          nameFile="social_1"
        />
      </div>
    </>
  )
}

export default Socialinsureone